"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheManager = void 0;
const cache_type_1 = require("./cache.type");
const memory_cache_1 = require("./caches/memory.cache");
const indexed_db_cache_1 = require("./caches/indexed-db.cache");
const local_storage_cache_1 = require("./caches/local-storage.cache");
class CacheManager {
    constructor() {
        this.cacheMap = new Map();
    }
    getCache(type, namespace) {
        let cache = this.cacheMap.get(namespace);
        if (!cache) {
            cache = this.getCacheByType(type, namespace);
            this.cacheMap.set(namespace, cache);
        }
        return cache;
    }
    getCacheByType(type, namespace) {
        let cache;
        switch (type) {
            case cache_type_1.CacheType.MEMORY:
                cache = new memory_cache_1.MemoryCache(namespace);
                break;
            case cache_type_1.CacheType.LOCALSTORAGE:
                cache = new local_storage_cache_1.LocalStorageCache(namespace);
                break;
            case cache_type_1.CacheType.INDEXEDDB:
                cache = new indexed_db_cache_1.IndexedDB(namespace);
        }
        return cache;
    }
}
const cacheManager = new CacheManager();
exports.CacheManager = cacheManager;
